// Generated by Melange

import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as Stdlib__List from "melange/list.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function ClientMobile(Props) {
  let clients = Props.clients;
  const match = React.useState(function () {
    return 0;
  });
  const setIdx = match[1];
  const idx = match[0];
  const match$1 = React.useState(function () {
    
  });
  const setInt = match$1[1];
  const cardRef = React.useRef(null);
  const client = Stdlib__List.nth(clients, idx);
  React.useEffect((function () {
    const cardElement = cardRef.current;
    Belt__Belt_Option.map((cardElement == null) ? undefined : Caml_option.some(cardElement), (function (el) {
      el.classList.remove("opacity-0");
      const remove = setTimeout((function (param) {
        el.classList.add("opacity-0");
      }), 9700);
      return function (param) {
        clearTimeout(remove);
      };
    }));
    const intrvl = setInterval((function (param) {
      const nextIdx = idx + 1 | 0;
      if (nextIdx < Stdlib__List.length(clients)) {
        return Curry._1(setIdx, (function (param) {
          return nextIdx;
        }));
      } else {
        return Curry._1(setIdx, (function (param) {
          return 0;
        }));
      }
    }), 10000);
    Curry._1(setInt, (function (param) {
      return Caml_option.some(intrvl);
    }));
    return (function (param) {
      clearInterval(intrvl);
    });
  }), [idx]);
  const clientImage = client.imageMobile;
  const clientBg = client.background;
  return JsxRuntime.jsxs("div", {
    ref: cardRef,
    children: [
      JsxRuntime.jsx("div", {
        className: "bg-cover bg-center h-55 mt-8 " + clientImage
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("p", {
            children: client.quote,
            className: "paragraph text-center text-white"
          }),
          JsxRuntime.jsx("img", {
            className: "flex m-auto mt-8 w-21.5 h-14",
            alt: "buhta",
            src: StaticAsset.src(client.logo)
          }),
          JsxRuntime.jsx("p", {
            children: client.name,
            className: "paragraph-small text-center text-white mt-4"
          })
        ],
        className: "py-10 px-6 " + clientBg
      })
    ],
    className: "opacity-0 transition-opacity duration-250"
  });
}

const make = ClientMobile;

export {
  make,
}
/* react Not a pure module */
